import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getCategoryPageAttr, getProductsByCategory } from "../apis/product";
import { CategorySlugContext } from "../context";
import { useContext } from "react";

import { ICategory } from "../models/category";

const useProductCategoryPageAttr = (): UseQueryResult<ICategory> => {
  const slug = useContext(CategorySlugContext);

  const fetchAttrs = () => {
    return getCategoryPageAttr(slug);
  };

  const result = useQuery(["CategoryPageAttr", slug], fetchAttrs, {
    staleTime: Infinity,
  });

  return result;
};

export default useProductCategoryPageAttr;
